<template>
  <div class="headFixed freshStatus">
    <HeadNav title="从板状态"></HeadNav>
    <router-link :to="'/equipment'"><p class="freshHome">主页</p></router-link>
    <!-- 会员 -->
    <div v-if="vip">
      <div v-if="pageNum == 1">
        <p class="freshTitle">从板用户参数</p>
        <div class="list list_normal list_no_arrow list_info">
          <div class="item">
            <div class="clear">
              <p>
                在家制冷温度设定
                <span class="right">
									<span class="black">{{
                      eqParams && eqParams.zaijiazhilengwendusheding2 ? eqParams.zaijiazhilengwendusheding2 : 0
                    }}</span>
									℃
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                在家制热温度设定
                <span class="right">
									<span class="black">{{
                      eqParams && eqParams.zaijiazhirewendusheding2 ? eqParams.zaijiazhirewendusheding2 : 0
                    }}</span>
									℃
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                在家制冷湿度设置
                <span class="right">
									<span class="black">{{
                      eqParams && eqParams.zaijiazhilengshidusheding2 ? eqParams.zaijiazhilengshidusheding2 : 0
                    }}</span>
									%
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                在家制热湿度设置
                <span class="right">
									<span class="black">{{
                      eqParams && eqParams.zaijiazhireshidusheding2 ? eqParams.zaijiazhireshidusheding2 : 0
                    }}</span>
									%
								</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div v-if="pageNum == 2">
        <p class="freshTitle">从板状态参数</p>
        <div class="list list_normal list_no_arrow list_info">
          <div class="item">
            <div class="clear">
              <p>
                系统状态
                <span class="right">
									<span class="black">
										{{
                      eqParams && eqParams.xitongzhuangtai2
                          ? eqParams.xitongzhuangtai2 == 0
                              ? '正常关机'
                              : eqParams.xitongzhuangtai2 == 1
                                  ? '远程关机'
                                  : eqParams.xitongzhuangtai2 == 2
                                      ? '故障关机'
                                      : eqParams.xitongzhuangtai2 == 3
                                          ? '定时关机'
                                          : eqParams.xitongzhuangtai2 == 4
                                              ? '正常关机'
                                              : eqParams.xitongzhuangtai2 == 5
                                                  ? '定时开机'
                                                  : eqParams.xitongzhuangtai2 == 6
                                                      ? '机组防冻'
                                                      : eqParams.xitongzhuangtai2 == 7
                                                          ? '预热开机'
                                                          : eqParams.xitongzhuangtai2 == 8
                                                              ? '预热关机'
                                                              : eqParams.xitongzhuangtai2 == 9
                                                                  ? '正在关机'
                                                                  : '待机'
                          : '待机'
                    }}
									</span>
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                送风微压
                <span class="right">
									<span class="black">{{ eqParams && eqParams.songfengweiya2 ? eqParams.songfengweiya2 : 0 }}</span>
									kpa
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                回风温度
                <span class="right">
									<span class="black">{{ eqParams && eqParams.huifengwendu2 ? eqParams.huifengwendu2 : 0 }}</span>
									℃
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                回风湿度
                <span class="right">
									<span class="black">{{ eqParams && eqParams.huifengshidu2 ? eqParams.huifengshidu2 : 0 }}</span>
									%
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                出风温度
                <span class="right">
									<span class="black">{{ eqParams && eqParams.chufengwendu2 ? eqParams.chufengwendu2 : 0 }}</span>
									℃
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                新风微压
                <span class="right">
									<span class="black">{{ eqParams && eqParams.xinfengweiya2 ? eqParams.xinfengweiya2 : 0 }}</span>
									kpa
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                露点温度
                <span class="right">
									<span class="black">{{ eqParams && eqParams.ludianwendu2 ? eqParams.ludianwendu2 : 0 }}</span>
									℃
								</span>
              </p>
            </div>
          </div>

          <div class="item">
            <div class="clear">
              <p>
                加湿器温度
                <span class="right">
									<span class="black">{{ eqParams && eqParams.jiashiqiwendu2 ? eqParams.jiashiqiwendu2 : 0 }}</span>
									℃
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                顶棚一次出水
                <span class="right">
									<span class="black">{{
                      eqParams && eqParams.dingpengyicichushui2 ? eqParams.dingpengyicichushui2 : 0
                    }}</span>
									℃
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                顶棚二次进水
                <span class="right">
									<span class="black">{{
                      eqParams && eqParams.dingpengercijinshui2 ? eqParams.dingpengercijinshui2 : 0
                    }}</span>
									℃
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                顶棚二次出水
                <span class="right">
									<span class="black">{{
                      eqParams && eqParams.dingpengercichushui2 ? eqParams.dingpengercichushui2 : 0
                    }}</span>
									℃
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                表冷器进水
                <span class="right">
									<span class="black">{{
                      eqParams && eqParams.biaolengqijinshui2 ? eqParams.biaolengqijinshui2 : 0
                    }}</span>
									℃
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                表冷器出水
                <span class="right">
									<span class="black">{{
                      eqParams && eqParams.biaolengqichushui2 ? eqParams.biaolengqichushui2 : 0
                    }}</span>
									℃
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                排风机
                <span class="right">
									<span class="black">{{ eqParams && eqParams.paifengji2 ? eqParams.paifengji2 : 0 }}</span>
									v
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                新风机
                <span class="right">
									<span class="black">{{ eqParams && eqParams.xinfengji2 ? eqParams.xinfengji2 : 0 }}</span>
									v
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                送风机
                <span class="right">
									<span class="black">{{ eqParams && eqParams.songfengji2 ? eqParams.songfengji2 : 0 }}</span>
									v
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                表冷器三通阀
                <span class="right">
									<span class="black">{{
                      eqParams && eqParams.biaolengqisantongfa2 ? eqParams.biaolengqisantongfa2 : 0
                    }}</span>
									v
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                辐射三通阀
                <span class="right">
									<span class="black">{{ eqParams && eqParams.fushesantongfa2 ? eqParams.fushesantongfa2 : 0 }}</span>
									v
								</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div v-if="pageNum == 3">
        <p class="freshTitle">从板输出参数</p>
        <div class="list list_normal list_no_arrow list_info">
          <div class="item">
            <div class="clear">
              <p>
                负氧离子
                <span class="right">
									<span class="black">{{ eqParams && eqParams.fuyanglizi2 == 1 ? '开' : '关' }}</span>
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                顶棚辐射泵
                <span class="right">
									<span class="black">{{ eqParams && eqParams.dingpengfushebeng2 == 1 ? '开' : '关' }}</span>
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                一次泵
                <span class="right">
									<span class="black">{{ eqParams && eqParams.yicibeng2 == 1 ? '开' : '关' }}</span>
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                加湿器排水
                <span class="right">
									<span class="black">{{ eqParams && eqParams.jiashiqipaishui2 == 1 ? '开' : '关' }}</span>
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                加湿器补水
                <span class="right">
									<span class="black">{{ eqParams && eqParams.jiashiqibushui2 == 1 ? '开' : '关' }}</span>
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                加湿器加湿
                <span class="right">
									<span class="black">{{ eqParams && eqParams.jiashiqijiashi2 == 1 ? '开' : '关' }}</span>
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                精加热
                <span class="right">
									<span class="black">{{ eqParams && eqParams.jingjiare2 == 1 ? '开' : '关' }}</span>
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                排风机
                <span class="right">
									<span class="black">{{ eqParams && eqParams.y07paifengji2 == 1 ? '开' : '关' }}</span>
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                新风机
                <span class="right">
									<span class="black">{{ eqParams && eqParams.y10xinfengji2 == 1 ? '开' : '关' }}</span>
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                除湿压缩机
                <span class="right">
									<span class="black">{{ eqParams && eqParams.y11chushiyasuoji2 == 1 ? '开' : '关' }}</span>
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                多功能杀菌仪
                <span class="right">
									<span class="black">{{ eqParams && eqParams.y15duogongnengshajunyi2 == 1 ? '开' : '关' }}</span>
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                送风机
                <span class="right">
									<span class="black">{{ eqParams && eqParams.y16songfengji2 == 1 ? '开' : '关' }}</span>
								</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div v-if="pageNum == 4">
        <p class="freshTitle">主板输入参数</p>
        <div class="list list_normal list_no_arrow list_info">
          <div class="item">
            <div class="clear">
              <p>
                水泵故障
                <span class="right">
									<span class="black">{{ eqParams && eqParams.x00shuibengguzhang2 == 1 ? '开' : '关' }}</span>
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                防冻开关1
                <span class="right">
									<span class="black">{{ eqParams && eqParams.x01fangdongkaiguan2 == 1 ? '开' : '关' }}</span>
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                防冻开关2
                <span class="right">
									<span class="black">{{ eqParams && eqParams.x02fangdongkaiguan2 == 1 ? '开' : '关' }}</span>
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                燃气报警
                <span class="right">
									<span class="black">{{ eqParams && eqParams.x03ranqibaojing2 == 1 ? '开' : '关' }}</span>
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                漏水报警
                <span class="right">
									<span class="black">{{ eqParams && eqParams.x04loushuibaojing2 == 1 ? '开' : '关' }}</span>
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                露点报警
                <span class="right">
									<span class="black">{{ eqParams && eqParams.x05ludianbaojing2 == 1 ? '开' : '关' }}</span>
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                加湿器漏水
                <span class="right">
									<span class="black">{{ eqParams && eqParams.x06jiashiqiloushui2 == 1 ? '开' : '关' }}</span>
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                加湿器过热
                <span class="right">
									<span class="black">{{ eqParams && eqParams.x07jiashiqiguore2 == 1 ? '开' : '关' }}</span>
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                加湿器水位上限
                <span class="right">
									<span class="black">{{ eqParams && eqParams.x10jiashiqishuiweishangxian2 == 1 ? '开' : '关' }}</span>
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                加湿器水位下限
                <span class="right">
									<span class="black">{{ eqParams && eqParams.x11jiashiqishuiweixiaxian2 == 1 ? '开' : '关' }}</span>
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                高效过滤
                <span class="right">
									<span class="black">{{ eqParams && eqParams.x12gaoxiaoguolv2 == 1 ? '开' : '关' }}</span>
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                初中效过滤
                <span class="right">
									<span class="black">{{ eqParams && eqParams.x13chuzhongxiaoguolv2 == 1 ? '开' : '关' }}</span>
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                送风风压差
                <span class="right">
									<span class="black">{{ eqParams && eqParams.x14songfengfengyacha2 == 1 ? '开' : '关' }}</span>
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                除湿压机故障
                <span class="right">
									<span class="black">{{ eqParams && eqParams.x15chushiyajiguzhang2 == 1 ? '开' : '关' }}</span>
								</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="page">
        <div class="btn-primary pagePrev" @click="goPrev()" v-if="pageNum > 1">上一页</div>
        <div class="btn-orange pageNext" @click="goNext()" v-if="pageNum < 4">下一页</div>
      </div>
    </div>

    <div v-else>
      <div v-if="pageNum == 1">
        <p class="freshTitle">从板输出参数</p>
        <div class="list list_normal list_no_arrow list_info">
          <div class="list-item"><p :class="eqParams && eqParams.fuyanglizi2 == 1 ? 'on' : 'off'">负氧离子</p></div>
          <div class="list-item"><p :class="eqParams && eqParams.dingpengfushebeng2 == 1 ? 'on' : 'off'">顶棚辐射泵</p>
          </div>
          <div class="list-item"><p :class="eqParams && eqParams.yicibeng2 == 1 ? 'on' : 'off'">一次泵</p></div>
          <div class="list-item"><p :class="eqParams && eqParams.jiashiqipaishui2 == 1 ? 'on' : 'off'">加湿器排水</p>
          </div>
          <div class="list-item"><p :class="eqParams && eqParams.jiashiqibushui2 == 1 ? 'on' : 'off'">加湿器补水</p>
          </div>
          <div class="list-item"><p :class="eqParams && eqParams.jiashiqijiashi2 == 1 ? 'on' : 'off'">加湿器加湿</p>
          </div>
          <div class="list-item"><p :class="eqParams && eqParams.jingjiare2 == 1 ? 'on' : 'off'">精加热</p></div>
          <div class="list-item"><p :class="eqParams && eqParams.y07paifengji2 == 1 ? 'on' : 'off'">排风机</p></div>
          <div class="list-item"><p :class="eqParams && eqParams.y10xinfengji2 == 1 ? 'on' : 'off'">新风机</p></div>
          <div class="list-item"><p :class="eqParams && eqParams.y11chushiyasuoji2 == 1 ? 'on' : 'off'">除湿压缩机</p>
          </div>
          <div class="list-item"><p :class="eqParams && eqParams.y15duogongnengshajunyi2 == 1 ? 'on' : 'off'">
            多功能杀菌仪</p></div>
          <div class="list-item"><p :class="eqParams && eqParams.y16songfengji2 == 1 ? 'on' : 'off'">送风机</p></div>
        </div>
      </div>

      <!--    <div class="page">
      <div class="btn-primary pagePrev" @click="goPrev()" v-if="pageNum>1">上一页</div>
      <div class="btn-orange pageNext" @click="goNext()" v-if="pageNum<2">下一页</div>
    </div> -->
    </div>
  </div>
</template>
<script>
import HeadNav from '../../headNav/headNav';

export default {
  name: 'info',
  data() {
    return {
      vip: null,
      info: {
        sendInWaterTemerature: null, // 送水回水温度
        sendOutWaterTemerature: null, // 送水出水温度
        coolInWaterTemerature: null, // 冷凝回水温度
        coolOutWaterTemerature: null //冷凝出水温度
      },
      // path: "ws://www.192.168.1.103:80/auto-equipment/websocketDemo/",
      socket: '',
      eqParams: null,
      pageNum: 1
    };
  },
  components: {
    HeadNav: HeadNav
  },
  mounted() {
    // this.readWaterTemerature();
    this.firstRequest = true;
    this.getFreshEquipmentDetail();
    this.vips();
  },

  beforeDestroy() {
    // this.socketclose();
  },
  methods: {
    vips() {
      let token = localStorage.getItem('token');
      // 拆分JWT令牌
      const parts = token.split('.');

      // 获取JWT payload（部分1）
      const payload = parts[1];

      // 将base64编码的payload解码为UTF-8字符串
      const decodedPayload = b64utoutf8(payload);

      // 解析JSON格式的payload
      const parsedPayload = JSON.parse(decodedPayload);
      this.vip = parsedPayload['vip'];
    },
    readWaterTemerature() {
      let str = 'id=' + this.getId();
      this.Api.eqDetail(this.getId(), msg => {
        if (msg.code == 200) {
          this.info = msg.body;

          //初始化websocket
          if (typeof WebSocket === 'undefined') {
            alert('您的浏览器不支持socket');
          } else {
            // 实例化socket
            this.socket = this.$store.state.websocket
            if (!this.socket) {
              this.socket = new WebSocket(this.$websocketUrl + this.eqInfo.iotDeviceId);
            }
            // 监听socket连接
            this.socket.onopen = this.socketopen;
            // 监听socket错误信息
            this.socket.onerror = this.socketerror;
            // 监听socket消息
            this.socket.onmessage = this.getMessage;
            // 关闭socket消息
            this.socket.onclose = this.socketclose;
            this.$store.commit('setWebSocket', this.socket);
          }

        }
      });
    },
    getId() {
      return this.$route.params.id;
    },
    socketopen: function () {
      console.log('socket连接成功');
    },
    socketerror: function () {
      console.log('连接错误');
    },
    getMessage: function (msg) {
      let data = JSON.parse(msg.data);
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          // 使用 Vue.$set 确保触发响应性更新
          this.$set(this.eqInfo.airVentilator, key, data[key]);
        }
      }
    },
    socketclose: function () {
      console.log('socket已经关闭');
      this.socket.close();
    },
    getFreshEquipmentDetail() {
      let id = this.getId();
      this.Api.freshEquipmentDetail('equipmentId=' + id, msg => {
        if (msg.body) {
          this.eqParams = msg.body;
        }
      });
    },
    goPrev() {
      let pageNum = this.pageNum;
      pageNum--;
      if (pageNum <= 1) {
        pageNum = 1;
      }
      this.pageNum = pageNum;
    },
    goNext() {
      let pageNum = this.pageNum;
      pageNum++;
      this.pageNum = pageNum;
    }
  }
};
</script>
<style scoped>
@import url('../../../assets/list.css');
</style>



// WEBPACK FOOTER //
// src/components/freshAir/status/status7.vue